export enum EmergencyCare {
    URGENT_CARE = "Urgent care facility",
    EMERGENCY_ROOM = "Emergency room",
    OBSERVATION_UNIT = "Observation unit",
    GROUND_OR_WATER_AMBULANCE = "Ground or water ambulance",
    AIR_AMBULANCE = "Air ambulance"
}